export default "__VITE_ASSET__CfUVu9uG__"